<template>
  <div class="container u-p1">
    <p v-show="$route.path === '/'" v-if="!$whitelabel.showHeaderLogo && $whitelabel.short.toLowerCase() === 'urlaubsguru'" style="line-height:1.25" class="is-hidden-desktop is-size-5 has-text-centered-tablet px-3 has-text-weight-bold mb-5">
      Urlaubsgutscheine <span class="is-block-mobile is-size-7-mobile is-6-tablet"> <span class="is-hidden-mobile">–</span> bis zu 70% günstiger</span>
    </p>

    <Banners v-if="$whitelabel.campaignsEnabled" />

    <h1 class="title" v-if="$route.path !== '/'">{{ title }}</h1>
    <h2 class="subtitle" v-if="$route.path !== '/'">
      <strong v-for="c in filter.countries" :key="c">{{ c | country }}</strong>
      <strong v-for="t in filter.themes" :key="t">{{ t | theme }}</strong>
    </h2>

    <section class="mb-5 is-hidden-print" id="searchbox">
      <SearchAutoComplete :id="'searchinput-autocomplete-mobile'" ref="autocompleteOne" class="is-hidden-tablet" :presetText.sync="filter.text" @execute-search="searchText" :buttonType="'icon'"></SearchAutoComplete>

      <b-collapse class="card" :open="false" aria-id="searchFilter" ref="searchCollapse">
        <div slot="trigger" slot-scope="props" class="card-header is-hidden-tablet" role="button" aria-controls="searchFilter">
          <p class="card-header-title">{{ $t('general.filter') }} / {{ $t('general.sort') }}</p>
          <a class="card-header-icon">
            <b-icon :icon="props.open ? 'chevron-up' : 'chevron-down'" aria-hidden="true"></b-icon>
            <span class="is-sr-only"> {{ $t('general.filter') }}: {{ $t('general.open') }} {{ $t('general.close') }} </span>
          </a>
        </div>
        <div class="card-content">
          <div class="columns is-multiline is-4 is-variable u-is-vend ">
            <SearchAutoComplete :id="'searchinput-autocomplete-desktop'" ref="autocompleteTwo" :presetText="filter.text" @execute-search="searchText" class="is-hidden-mobile column is-12-tablet is-6-widescreen is-12-fullhd is-marginless" :buttonType="'text'"></SearchAutoComplete>
            <div class="column is-6-tablet is-3-widescreen is-2-fullhd">
              <b-field :label="$t('general.nights')" v-if="filter.maxNights && filter.minNights < filter.maxNights">
                <b-slider :aria-label="[$t('general.min-nights'), $t('general.max-nights')]" @change="search" v-model="filter.nightsArray" :min="filter.minNights" :max="filter.maxNights" :step="1" class="b-slider--narrow">
                  <b-slider-tick :value="filter.minNights">
                    {{ filter.minNights }} <span class="is-sr-only">{{ $t('general.nights') }}</span>
                  </b-slider-tick>
                  <b-slider-tick :value="filter.maxNights">
                    {{ filter.maxNights }} <span class="is-sr-only">{{ $t('general.nights') }}</span>
                  </b-slider-tick>
                </b-slider>
              </b-field>
            </div>
            <div class="column is-6-tablet is-3-widescreen is-3-fullhd">
              <b-field :label="$t('general.price')" v-if="filter.maxPrice && filter.minPrice < filter.maxPrice">
                <b-slider :aria-label="[$t('general.min-price'), $t('general.max-price')]" v-model="filter.priceArray" @change="search" :min="filter.minPrice" :max="filter.maxPrice" :step="1" class="b-slider--narrow">
                  <b-slider-tick :value="filter.minPrice">{{ filter.minPrice }}</b-slider-tick>
                  <b-slider-tick :value="filter.maxPrice">{{ filter.maxPrice }}</b-slider-tick>
                </b-slider>
              </b-field>
            </div>
            <div class="column checkbox-button--justified is-8-tablet is-9-widescreen is-4-fullhd">
              <label class="label">{{ $t('search.category') }}</label>
              <b-field class="u-flexwrap--phone">
                <b-checkbox-button @input="search" v-model="filter.categories" native-value="3" type="is-dark">
                  3&nbsp; <span class="is-sr-only">{{ $t('general.stars') }}</span>
                  <sup>
                    <b-icon icon="star" size="is-small"></b-icon>
                  </sup>
                </b-checkbox-button>
                <b-checkbox-button @input="search" v-model="filter.categories" native-value="4" type="is-dark">
                  3&nbsp; <span class="is-sr-only">{{ $t('general.stars') }}</span>
                  <sup> <b-icon icon="star" size="is-small"></b-icon>&nbsp;s </sup>
                </b-checkbox-button>
                <b-checkbox-button @input="search" v-model="filter.categories" native-value="5" type="is-dark">
                  4&nbsp; <span class="is-sr-only">{{ $t('general.stars') }}</span>
                  <sup>
                    <b-icon icon="star" size="is-small"></b-icon>
                  </sup>
                </b-checkbox-button>
                <b-checkbox-button @input="search" v-model="filter.categories" native-value="6" type="is-dark">
                  4&nbsp; <span class="is-sr-only">{{ $t('general.stars') }}</span>
                  <sup> <b-icon icon="star" size="is-small"></b-icon>&nbsp;s </sup>
                </b-checkbox-button>
                <b-checkbox-button @input="search" v-model="filter.categories" native-value="7" type="is-dark">
                  5&nbsp; <span class="is-sr-only">{{ $t('general.stars') }}</span>
                  <sup>
                    <b-icon icon="star" size="is-small"></b-icon>
                  </sup>
                </b-checkbox-button>
                <!-- <b-checkbox-button @input="search" v-model="filter.categories" native-value="8" type="is-dark" v-if="!$whitelabel.hide5sup">
                  5&nbsp;
                    <sup> <b-icon icon="star" size="is-small"></b-icon>&nbsp;s </sup>
                </b-checkbox-button> -->
              </b-field>
            </div>
            <div class="column is-4-tablet is-3-widescreen is-3-fullhd">
              <b-field>
                <b-select
                  :placeholder="$t('search.sorting')"
                  :aria-label="$t('search.sorting')"
                  @input="
                    search()
                    scrollToResult()
                  "
                  v-model="filter.sortBy"
                  rounded
                  expanded
                >
                  <option value="priceAsc">{{ $t('search.price_asc') }}</option>
                  <option value="priceDesc">{{ $t('search.price_desc') }}</option>
                  <option value="catAsc">{{ $t('search.category_asc') }}</option>
                  <option value="catDesc">{{ $t('search.category_desc') }}</option>
                  <option value="newFirst">{{ $t('search.newest_first') }}</option>
                  <option value="weRecommend">{{ $t('search.recommended') }}</option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-12">
              <div class="columns is-multiline">
                <div class="column is-12-tablet is-3-desktop is-2-widescreen">
                  <b-button size="is-small" type="is-dark" icon-left="search-plus" aria-controls="refine-search" @click="isDetailsOpen = !isDetailsOpen">{{ $t('search.refine_results') }}</b-button>
                </div>
                <div id="refine-search" class="column is-12-tablet" v-show="isDetailsOpen">
                  <div class="columns is-multiline is-variable is-1">
                    <!-- <div class="column is-3-desktop is-4-tablet" v-for="(v, i) in tags" :key="i"> -->
                    <div class="column is-6-tablet is-4-desktop is-3-widescreen" v-for="(v, i) in tags" :key="i" v-show="v.length > 1 && notIn(v).length > 0">
                      <div class="control">
                        <strong>
                          <span class="is-sr-only">{{ $t('general.filter') }}</span>
                          {{ $t(`auto-tags.${i.toLowerCase()}`) }}
                        </strong>
                        <div class="buttons">
                          <b-button @click="add(val)" type="is-light" size="is-small" v-for="val in topNotInFilter(6, v)" :key="val" v-show="val && val.length > 0">{{ val }}</b-button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div role="alert" aria-live="polite">
                    <small class="has-text-weight-bold" v-show="filter.tags.length > 0">{{ $t('search.result_for') }}</small>
                    <b-field grouped group-multiline>
                      <div class="control" v-for="(v, i) in filter.tags" :key="i">
                        <b-tag close-type="is-primary" type="is-dark" attached closable :aria-close-label="`${v} entfernen`" @close="remove(v)">
                          <span class="is-sr-only">{{ $t('general.filter') }}</span> {{ v }}
                        </b-tag>
                      </div>
                    </b-field>
                  </div>
                </div>
              </div>
            </div>
            <!-- <RequestWish></RequestWish> -->
          </div>
        </div>
      </b-collapse>
    </section>

    <PromotionModal />
    <SearchList :products="products" class="mb-5" id="searchlist" />
    <b-pagination
      v-if="totalCount > pageSize"
      class="is-hidden-print"
      :order="'is-right'"
      :aria-previous-label="$t('general.previous-page')"
      :aria-current-label="$t('general.current-page')"
      :aria-next-label="$t('general.next-page')"
      :total="totalCount"
      :current="currentPage"
      @change="changePage"
      :per-page="pageSize"
      :rounded="true"
    ></b-pagination>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import store from './_store'
import SearchList from './_components/SearchList'
import SearchAutoComplete from './_components/SearchAutoComplete'
import PromotionModal from '@/components/PromotionModal'
// import RequestWish from '@/components/RequestWish'

import Banners from '@/components/Banner/_Banners'

export default {
  name: 'SearchModule',
  components: {
    SearchList,
    PromotionModal,
    SearchAutoComplete,
    Banners,
    // RequestWish,
  },
  computed: {
    ...mapGetters({
      products: '$_search/products',
      totalCount: '$_search/totalCount',
      currentPage: '$_search/page',
      pageSize: '$_search/pageSize',
      filter: '$_search/filter',
      tags: '$_search/available_tags',
      title: '$_search/title',
      locale: 'locale',
      // minNights: '$_search/minNights',
      // maxNights: '$_search/maxNights',
      // minPrice: '$_search/minPrice',
      // maxPrice: '$_search/maxPrice',
    }),
  },
  data() {
    return {
      isCodeModalActive: false,
      currentTitle: '',
      hideText: true,
      isDetailsOpen: false,
    }
  },
  created() {
    const STORE_KEY = '$_search'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
    this.$store.subscribe(mutation => {
      if (mutation.type == 'LOCALE_CHANGED') {
        //this.$store.dispatch('$_search/getProducts', this.filter)
        this.updateProducts()
      }
    })
  },
  mounted() {
    const to = this.$route
    if (to.name == 'search-by-theme') {
      this.$store.dispatch('$_search/setThemeMode', to.params)
    }
    if (to.name == 'search-by-country') {
      this.$store.dispatch('$_search/setCountryMode', to.params)
    }
    if (to.name == 'search') {
      this.$store.dispatch('$_search/setDefaultSearchMode')
    }
    if (to.name == 'search-keyword') {
      this.$store.dispatch('$_search/setKeywordSearchMode', to.params.keyword)
    }
    if (to.name == 'promotion-redirect' && to.params && to.params.promotion) {
      this.$store.dispatch('$_search/setDefaultSearchMode')
      this.$store.dispatch('applyReduction', to.params.promotion)
    }
    if (this.$route.query && Object.keys(this.$route.query).length > 0) {
      this.$store.dispatch('$_search/updateFilterFrom', this.$route.query)
    }

    if (this.$whitelabel.short.toLowerCase() === 'adac') {
      this.$store.dispatch('$_search/changeSortBy', 'newFirst')
    }
    this.$store.dispatch('$_search/getProducts', this.filter)

    this.updateProducts()
    //show filters up from tablet
    if (window.innerWidth >= 768) {
      this.$refs.searchCollapse.toggle()
    }

    this.setMeta()
    this.emitBreadcrumb()
  },
  beforeDestroy() {},
  watch: {
    $route(to, from) {
      if (from && to.path !== from.path) {
        this.$refs.autocompleteOne.reset()
        this.$refs.autocompleteTwo.reset()
        this.$store.dispatch('$_search/resetSearch')
      }
      if (to.path !== from.path) {
        if (to.name == 'search-by-theme') {
          this.$store.dispatch('$_search/setThemeMode', to.params)
        }
        if (to.name == 'search-by-country') {
          this.$store.dispatch('$_search/setCountryMode', to.params)
        }
        if (to.name == 'search') {
          this.$store.dispatch('$_search/setDefaultSearchMode')
        }
        if (to.name == 'search-keyword') {
          this.$store.dispatch('$_search/setKeywordSearchMode', to.params.keyword)
        }
      }

      if (from && to.path !== from.path) {
        //this.$store.dispatch('$_search/getProducts', this.filter)
        this.updateProducts()
        this.setMeta()
        this.emitBreadcrumb()
      }
    },
  },
  methods: {
    top(c, a) {
      if (a && a.length > c) {
        return a.slice(0, c)
      }
      return a
    },
    notIn(a) {
      return a.filter(f => !this.filter.tags.includes(f))
    },
    topNotInFilter(c, a) {
      const b = this.notIn(a)
      if (b && b.length > c) {
        return b.slice(0, c)
      }
      return b
    },
    async changePage(e) {
      this.$scrollTo('#searchbox')

      await this.$store.dispatch('$_search/changePage', {
        filter: this.filter,
        page: e,
      })
      this.updateQueryParameters()
    },
    search() {
      this.updateQueryParameters()
      //this.$store.dispatch('$_search/getProducts', this.filter)
      this.updateProducts()
    },
    searchText(text) {
      this.filter.text = text
      try {
        this.$ga.page(window.location.pathname + '?q=' + text)
      } catch {
        //todo logging
      }
      this.updateQueryParameters()
      //this.$store.dispatch('$_search/getProducts', this.filter)
      this.updateProducts()
    },
    add(tag) {
      this.$store.dispatch('$_search/addTag', tag)
      this.updateQueryParameters()
      //this.$store.dispatch('$_search/getProducts', this.filter)
      this.updateProducts()
    },
    remove(tag) {
      this.$store.dispatch('$_search/removeTag', tag)
      this.updateQueryParameters()
      //this.$store.dispatch('$_search/getProducts', this.filter)
      this.updateProducts()
    },
    async updateProducts() {
      await this.$store.dispatch('$_search/getProducts', this.filter)
    },
    updateQueryParameters() {
      if (!this.$route.query || JSON.stringify(this.$route.query) !== JSON.stringify(this.filter)) {
        this.$router.push({query: this.filter})
      }
    },
    animatePrices() {
      this.isCodeModalActive = false
      this.$root.$emit('animatePrices')
      this.$refs.codenotification.close()
    },
    setMeta() {
      //get current theme or title
      const theme = this.$options.filters.theme(this.filter.themes[0])
      const country = this.$options.filters.country(this.filter.countries[0])
      this.currentTitle = theme === '' ? country : theme //set meta title
    },
    emitBreadcrumb() {
      this.$emit('update:breadcrumb', 'theme-or-country')
    },
    scrollToResult() {
      this.$scrollTo('#sorting', 500, {
        offset: -160,
      })
    },
  },
  metaInfo() {
    let title = this.currentTitle === '' ? 'Suche' : `${this.currentTitle}-Angebote`

    let metaDescription = `Durchstöbern Sie unsere ${this.currentTitle} Angebote und wählen Sie Ihren gewünschten Kurzurlaub aus! Reisen Sie clever & günstig mit Urlaubsgutscheinen!`

    if (this.$route.name === 'home' && this.$whitelabel.metaDescription != undefined) {
      metaDescription = this.$whitelabel.metaDescription
    }

    if (this.$route.name === 'home' && this.$whitelabel.metaTitle != undefined) {
      title = this.$whitelabel.metaTitle
    }

    return {
      title: title,
      meta: [
        {
          name: 'description',
          content: metaDescription,
        },
      ],
    }
  },
}
</script>
